import { styled } from "styled-components";

export const DropDownName = styled.p`
  padding: 4px 8px;
  color: #64748B;
  font-size: 14px;
  font-weight: 500;
`;